var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInprogressTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2.5H7.81C4.17 2.5 2 4.67 2 8.31V16.68C2 20.33 4.17 22.5 7.81 22.5H16.18C19.82 22.5 21.99 20.33 21.99 16.69V8.31C22 4.67 19.83 2.5 16.19 2.5Z",
    fill: "#D99036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C11.44 13.5 11 13.05 11 12.5C11 11.95 11.45 11.5 12 11.5C12.55 11.5 13 11.95 13 12.5C13 13.05 12.56 13.5 12 13.5Z",
    fill: "#D99036"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5C15.44 13.5 15 13.05 15 12.5C15 11.95 15.45 11.5 16 11.5C16.55 11.5 17 11.95 17 12.5C17 13.05 16.56 13.5 16 13.5Z",
    fill: "#D99036"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C7.44 13.5 7 13.05 7 12.5C7 11.95 7.45 11.5 8 11.5C8.55 11.5 9 11.95 9 12.5C9 13.05 8.56 13.5 8 13.5Z",
    fill: "#D99036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressTicketIcon);
export default __webpack_public_path__ + "static/media/inprogressTicketIcon.f9a876f440d073b3745e6533051e9e85.svg";
export { ForwardRef as ReactComponent };